import styled from '@emotion/styled';
import classNames from 'classnames';
import React from 'react';

import * as stylesHeader from 'ui/layout/header/Header.module.less';

const AvatarPic = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  border-radius: 50%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-image: url(${({ path }) => path});
`;

/**
 * @type {React.FC<{ profilePicPath ?: string }>}
 */
const UserPicture = ({ profilePicPath }) => {
  const haveProfilePic = profilePicPath !== undefined;

  return (
    <React.Fragment>
      {haveProfilePic && (
        <div className={stylesHeader['header-usernav__avatar']}>
          <AvatarPic path={profilePicPath} />
        </div>
      )}
      {!haveProfilePic && <i className={classNames([stylesHeader['header-usernav__icon'], 'fb-icon--user'])} />}
    </React.Fragment>
  );
};

export default UserPicture;
